// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Popup from './components/Popup.js'
import Eject from './components/Eject.js'
import $ from 'jquery'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import Vant from 'vant';
import Cookies from 'js-cookie';
import 'vant/lib/index.css';
import Meta from 'vue-meta';
import { _get_site_notice_info } from './api'
import "babel-polyfill"
import VueClipboard from 'vue-clipboard2'
Vue.use(VueClipboard)

// 低版本IE（IE10以下）浏览器进行提示
var isIE = function (ver) {
  var b = document.createElement("b");
  b.innerHTML = "<!--[if IE " + ver + "]><i></i><![endif]-->";
  return b.getElementsByTagName("i").length === 1;
};
var errMsg = '不支持低版本IE浏览器，请在谷歌、火狐、Edge、360极速模式等浏览器打开！';
if (isIE(6) || isIE(7) || isIE(8) || isIE(9)) {
  throw errMsg;
}

Vue.config.productionTip = false
Vue.use(Cookies)
router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next()
})
Vue.use(Vant);
Vue.use(ElementUI);
Vue.use(Meta);
Vue.prototype.$msg = Vue.prototype.$message;
Vue.prototype.$popup = Popup.install
Vue.prototype.$eject = Eject.install
Vue.prototype.$Cookies = Cookies
var hrefInfo = location.host.split(".");
window.cookieDomain = '.'+hrefInfo[1]+'.'+hrefInfo[2];
let uid = Cookies.get('uid',{domain:window.cookieDomain});
let phone = Cookies.get('phone',{domain:window.cookieDomain});
if(uid != undefined && uid != '' && phone != undefined && phone != '') {
  let uinfo = new Object();
  uinfo.uid = uid;
  uinfo.phone = phone;
  store.state.userInfo = uinfo;
}

let useruid = Cookies.get('useruid',{domain:window.cookieDomain});
let userstr = Cookies.get('userstr',{domain:window.cookieDomain});
let userlevel = Cookies.get('userlevel',{domain:window.cookieDomain});
let nick = Cookies.get('nick',{domain:window.cookieDomain});
if(useruid != undefined && useruid != '' && userstr != undefined && userstr != '') {
  let userInfo = new Object();
  userInfo.useruid = useruid;
  userInfo.userstr = userstr;
  userInfo.userlevel = userlevel;
  userInfo.nick = nick;
  store.state.user = userInfo;
}

document.getElementsByTagName('body')[0].style.visibility='hidden';
router.afterEach( ( to, from, next ) => {
  setTimeout(()=>{
    var _hmt = _hmt || [];
    (function() {
        //每次执行前，先移除上次插入的代码
        document.getElementById('baidu_tj') && document.getElementById('baidu_tj').remove();
        var hm = document.createElement("script");
        hm.src = "https://hm.baidu.com/hm.js?9e1e0a1c427950221e8887f0b1d20819";
        hm.id = "baidu_tj"
        var s = document.getElementsByTagName("script")[0];
        s.parentNode.insertBefore(hm, s);
    })();
  },0);
  _get_site_notice_info({}).then(res => {
      document.getElementsByTagName('body')[0].style.visibility='hidden';
      document.getElementsByTagName('body')[0].innerHTML = "<div style='width:100%;text-align: center;font-size: 24px;color:#c9242b;margin-top:36px;line-height:30px;font-weight: bold;'>非常抱歉，我们的系统正在紧急维护，预计20分钟内完成，给您带来的不便敬请谅解！</div>"
      document.getElementsByTagName('body')[0].style.visibility='visible';
  }).catch(err => {
    document.getElementsByTagName('body')[0].style.visibility='visible';
  });
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
	data: function(){
		return {
	    ORDERID: '',
	  }
	},
  router,
  store,
  components: { App },
  template: '<App/>'
})




// WEBPACK FOOTER //
// ./src/main.js